import { Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useState, Fragment, startTransition } from "react";
import { Link, useLocation } from "react-router-dom";

import Ads from "../../../images_new/icon/ads.svg?react";
import User from "../../../images_new/icon/user.svg?react";
import Line from "../../../images_new/icon/line.svg?react";
import Help from "../../../images_new/icon/help.svg?react";
import Star from "../../../images_new/icon/star.svg?react";
import Sun from "../../../images_new/icon/bx_sun.svg?react";
import Power from "../../../images_new/icon/power.svg?react";
import Moon from "../../../images_new/icon/bx_moon.svg?react";
import Vault from "../../../images_new/icon/vault.svg?react";
import Lips from "../../../images_new/icon/performer.svg?react";
import LiveIcon from "../../../images/icons/Live_Icon.svg?react";
import Bookmark from "../../../images_new/icon/bookmark.svg?react";
import Settings from "../../../images_new/icon/settings.svg?react";
import Follower from "../../../images_new/icon/follower.svg?react";
import Following from "../../../images_new/icon/following.svg?react";
import Face2Face from "../../../images_new/icon/face2face.svg?react";
import VideoStore from "../../../images_new/icon/p_video.svg?react";

const SidebarMenu = ({ isDark, isNotVerified, isModel, designChange }) => {
  const [showListMenu, setShowListMenu] = useState(false);

  const toggle = () => {
    setShowListMenu(!showListMenu);
  };

  const location = useLocation();
  const navigate = useNavigate();

  const Menu = {
    profileMenu: [
      {
        id: 1,
        label: "Profile",
        path: "/profile",
        icon: User,
      },
      {
        id: 2,
        label: "Bookmarks",
        path: "/bookmarks",
        icon: Bookmark,
      },
    ],
    listMenu: [
      {
        id: 1,
        label: "Following",
        icon: Following,
        path: "/following",
      },
      {
        id: 2,
        label: "Followers",
        icon: Follower,
        path: "/fans",
      },
      {
        id: 3,
        label: "Favorite",
        icon: Star,
        path: "/favorites",
      },
      {
        id: 4,
        label: "Subscribers",
        icon: Follower,
        path: "/subscribers",
        hidden: !isModel()
      },
      {
        id: 5,
        label: "Subscriptions",
        icon: Follower,
        path: "/subscriptions"
      }
    ],
    featuresMenu: [
      {
        id: 1,
        label: "Live",
        icon: LiveIcon,
        path: "/live",
      },
      {
        id: 2,
        label: "Face2Face",
        icon: Face2Face,
        path: "/face2face",
      },
      {
        id: 3,
        label: "Video Store",
        icon: VideoStore,
        path: "/video-store",
      },
      {
        id: 4,
        label: "Ad Campaigns",
        path: "/ads",
        icon: Ads,
      },
    ],
    hubMenu: [
      {
        id: 1,
        label: isModel() ? "Performer's Hub" : "User's Hub",
        icon: Vault,
        path: "/cards",
      }
    ],
    otherMenu: [
      {
        id: 1,
        label: "Help and Support",
        icon: Help,
        path: "/help-and-support",
      },
      {
        id: 2,
        label: "Settings",
        icon: Settings,
        path: "/settings",
      },
      {
        id: 3,
        label: "Logout",
        icon: Power,
        path: "/logout",
      },
    ],
  };

  // Handler to wrap navigation in startTransition for lazy-loaded routes
  const handleNavigation = (e, path) => {
    e.preventDefault();
    startTransition(() => {
      navigate(path);
    });
  };

  return (
    <>
      <div className="w-100 d-flex flex-column align-items-center">
        <div className="w-100 d-flex flex-column justify-content-between">
          {Menu.profileMenu.map(({ id, path, label, icon: Icon }, index) => (
            <Link
              key={`profile-menu-${index}`}
              aria-label={`navigate to ${label}`}
              className={`sidebar-menu ${location.pathname === path ? "sidebar-link-active" : ""}`}
              onClick={(e) => handleNavigation(e, path)}
            >
              <div
                role={"button"}
                aria-label={label}
                key={`${id}-${label}`}
                className={`d-flex ham-menu-link}`}
              >
                <Icon className="ham-menu-icon mr-1" />
                <p className="ham-menu-label">{label}</p>
              </div>
            </Link>
          ))}
          {
            <div
              onClick={toggle}
              role="button"
              aria-label="up down"
              className={`sidebar-menu sidebar-menu-list`}
            >
              <Line fill="black" className="ham-menu-icon mr-1" />
              <p className="ham-menu-label">List</p>
              <i className={`menu-list-icon fas fa-chevron-${showListMenu ? "up" : "down"}`} />
            </div>
          }
          {showListMenu
            ? Menu.listMenu.map(({ id, label, icon: Icon, path, hidden }, index) => {
              if(!hidden) return (
                <Link
                  key={`list-menu-${index}`}
                  aria-label={`navigate to ${label}`}
                  className={`sidebar-menu ${location.pathname === path ? "sidebar-link-active" : ""}`}
                  onClick={(e) => handleNavigation(e, path)}
                >
                  <div
                    key={`${id}-${label}`}
                    role={"button"}
                    aria-label='menu'
                    className={`d-flex ham-menu-link`}
                  >
                    <Icon fill="black" className="ham-menu-icon mr-1" />
                    <p className="ham-menu-label">{label}</p>
                  </div>
                </Link>
              )

              return null
            })
            : null}
          <Divider className="list-divider" />
          {Menu.featuresMenu.map(({ id, label, icon: Icon, path, hidden }, index) => {
            if(!hidden) return (
              <Link
                aria-label={`navigate to ${label}`}
                key={`payment-menu-${index}`}
                className={`sidebar-menu ${location.pathname === path ? "sidebar-link-active" : ""}`}
                onClick={(e) => handleNavigation(e, path)}
              >
                <div
                  key={`${id}-${label}`}
                  role={"button"}
                  aria-label={label}
                  className={`d-flex ham-menu-link`}
                >
                  <Icon fill="black" className="ham-menu-icon mr-1" />
                  <p className="ham-menu-label">{label}</p>
                </div>
              </Link>
            )
          })}
          <Divider className="list-divider" />
          {Menu.hubMenu.map(({ id, label, icon: Icon, path }, index) => (
            <Link
            key={`payment-menu-${index}`}
            aria-label={`navigate to ${label}`}
            onClick={(e) => handleNavigation(e, path)}
            className={`sidebar-menu ${location.pathname === path ? "sidebar-link-active" : ""}`}
            >
              <div
                key={`${id}-${label}`}
                role={"button"}
                aria-label={label}
                className={`d-flex ham-menu-link`}
              >
                <Icon fill="black" className="ham-menu-icon mr-1" />
                <p className="ham-menu-label">{label}</p>
              </div>
            </Link>
          ))}
          {!isModel() || isNotVerified() ? (
            <Link
              role={"button"}
              className="d-flex ham-menu-link"
              aria-label="performer"
              onClick={(e) => handleNavigation(e, "/become-performer")}
            >
              <div role={"button"} className={`sidebar-menu`} aria-label="performer">
                <Lips fill="black" className="ham-menu-icon mr-1" />
                <p className="ham-menu-label">Become a performer</p>
              </div>
            </Link>
          ) : null}
          <Divider className="list-divider" />
          <div
            onClick={designChange}
            role="button"
            aria-label="light dark"
            className={`sidebar-menu-single sidebar-menu-list `}
          >
            {isDark ? <Sun /> : <Moon />}
            <p className="ham-menu-label ml-1">
              {isDark ? "Light Mode" : "Dark Mode"}
            </p>
          </div>
          <Divider className="list-divider" />
          {Menu.otherMenu.map(({ id, label, path, icon: Icon }, index) => (
            <Fragment key={`other-menu-${index}`}>
              <Link
                id={path === "/logout" ? "logout" : label}
                aria-label='navigate to logout'
                className={`sidebar-menu-single sidebar-menu-list ${location.pathname === path ? "sidebar-link-active" : ""}`}
                onClick={(e) => handleNavigation(e, path)}
              >
                <div
                  role={"button"}
                  aria-label={label}
                  key={`${id}-${label}`}
                  className={`d-flex ham-menu-link ${index === Menu.otherMenu.length - 1 ? "mb-3" : ""} `}
                >
                  <Icon fill="black" className="ham-menu-icon mr-1" />
                  <p className="ham-menu-label">{label}</p>
                </div>
              </Link>
              {index !== Menu.otherMenu.length - 1 ? (
                <Divider className="list-divider" />
              ) : null}
            </Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

export default SidebarMenu;
